import { render, staticRenderFns } from "./AcademicRecordsForm.vue?vue&type=template&id=0c8a83f4&scoped=true&"
import script from "./AcademicRecordsForm.vue?vue&type=script&lang=js&"
export * from "./AcademicRecordsForm.vue?vue&type=script&lang=js&"
import style0 from "./AcademicRecordsForm.vue?vue&type=style&index=0&id=0c8a83f4&lang=scss&scoped=true&"
import style1 from "./AcademicRecordsForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a83f4",
  null
  
)

export default component.exports